import { render, staticRenderFns } from "./LocaleListItemGroup.vue?vue&type=template&id=ce5bbf0e&scoped=true"
import script from "./LocaleListItemGroup.vue?vue&type=script&lang=ts"
export * from "./LocaleListItemGroup.vue?vue&type=script&lang=ts"
import style0 from "./LocaleListItemGroup.vue?vue&type=style&index=0&id=ce5bbf0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5bbf0e",
  null
  
)

export default component.exports